<template>
  <div class="part_change_detail_dialog">
    <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <div class="title">{{ $t('asm_part_change_dialog.gong_dan_xin_xi') }}</div>
        <div class="item-title-info">
          <el-row>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.gong_dan_bian_hao') }}:</span>
              <span class="value">{{ info.workOrderCode || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.chan_pin_xing_hao') }}:</span>
              <span class="value">{{ info.productCode || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.ji_shen_hao') }}:</span>
              <span class="value">{{ info.bodyNum || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.shou_hou_gong_si') }}:</span>
              <span class="value">{{ info.afterServiceName || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.zu_lin_fang') }}:</span>
              <span class="value">{{ info.customerName || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_change_dialog.xiang_mu') }}:</span>
              <span class="value">{{ info.locationName || '-' }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="title">{{ $t('asm_part_change_dialog.geng_huan_ming_xi') }}</div>
        <div class="table-dialog-bd">
          <custom-table-expand
            ref="customTb1"
            index
            :rowId="getRowKeys"
            :data="tableList"
            :column="tableColumn"
            @sort="sortChange"
            @filter="filterChange"
            @exChange="exChange"
            expand-row-keys
            expand
            :slots="['expand', 'action']"
          >
            <template slot="expand" slot-scope="scope">
              <div class="part-pic ub">
                <div style="margin-right: 60px" v-if="scope.row.beforeFileList && scope.row.beforeFileList.length">
                  <h1>{{ $t('asm_part_change_dialog.ljghq') }}</h1>
                  <ul class="ubw">
                    <li v-for="(item, index) in scope.row.beforeFileList" :key="index">
                      <img @click="onViewImage(item.attachPath)" :src="item.attachPath" alt />
                    </li>
                  </ul>
                </div>
                <div v-if="scope.row.afterFileList && scope.row.afterFileList.length">
                  <h1>{{ $t('asm_part_change_dialog.ljghh') }}</h1>
                  <ul class="ubw">
                    <li v-for="(item, index) in scope.row.afterFileList" :key="index">
                      <img @click="onViewImage(item.attachPath)" :src="item.attachPath" alt />
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <template slot="action" slot-scope="scope">
              <el-button v-if="scope.row.orderPartId" type="text" size="mini" @click="changePayer(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            </template>
          </custom-table-expand>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
    <part-changePayer-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></part-changePayer-dialog>
    <!-- 查看地图图片 -->
    <el-image-viewer style="z-index: 2200" v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTableExpand from '@/components/customTableExpand.vue';
import partChangePayerDialog from './part_changePayer_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    partChangePayerDialog,
    customTableExpand,
  },
  data() {
    return {
      tableCode: 'part_replace_detail',
      info: {},
      // 获取row的key值
      getRowKeys(row) {
        return row.recordPartReplaceId;
      },
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        bodyNum: '',
        workOrderId: '',
      },
      beforeFileList: [],
      afterFileList: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogVisibleImage: false,
      dialogImageUrl: '',
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },

  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'detail') {
        this.info = this.model.row;
        this.getTableList();
      }
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.workOrderId = this.info.workOrderId;
      this.formSearch.bodyNum = this.info.bodyNum;
      // this.formSearch.workOrderId = '570307114329165824';
      // this.formSearch.bodyNum = '202101120002';
      this.$getJSON(apis.workOrderPartDetailPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    exChange: function (row) {
      this.getAttachList(row);
    },
    // 查看图片
    onViewImage: function (url) {
      this.dialogVisibleImage = true;
      this.dialogImageUrl = url;
    },
    // 获取零件变更图片
    getAttachList: async function (item) {
      if (!item.orderPartId) {
        return;
      }
      await Promise.all([this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.old`), this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.new`)]).then(([beforeFileList, afterFileList]) => {
        beforeFileList.data.map(f => this.getAttachUrl(f));
        afterFileList.data.map(f => this.getAttachUrl(f));
        this.$set(item, 'beforeFileList', beforeFileList.data);
        this.$set(item, 'afterFileList', afterFileList.data);
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    changePayer: function (item) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_part_change_dialog.xiu_gai_fu_kuan_fang');
      this.dialogModel.row = item;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.part_change_detail_dialog {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 22px;
    font-size: 14px;
    margin-bottom: 16px;
    position: relative;
    padding-left: 10px;
    &:after {
      content: '';
      position: absolute;
      width: 4px;
      height: 15px;
      background: rgba(0, 175, 255, 1);
      left: 0px;
      top: 4px;
    }
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
